<nz-spin [nzSpinning]="loading">
  <sv-container col="1" size="large" layout="horizontal">
    <ng-container *ngIf="licenseInfo.productKey">
      <sv-title>
        <p nz-typography nzCopyable [nzContent]="licenseInfo.productKey"></p>
      </sv-title>
    </ng-container>

    <sv>
      <p nz-typography [nzContent]="licenseInfo.productName"></p>
    </sv>
    <nz-divider></nz-divider>
    <sv label="Plan" col="2" *ngIf="licenseInfo.plan">
      {{ licenseInfo.plan }}
    </sv>
    <sv label="Expiry" col="2" *ngIf="licenseInfo.expiryDate" type="success">
      {{ licenseInfo.expiryDate | date }}
      <button type="button" class="float-end" nz-button nzType="link" nzSize="small" (click)="showManagePlan()" *ngIf="canManagePlan">
        Manage Plan
      </button>
    </sv>
    <sv label="Expiry" col="2" *ngIf="!licenseInfo.expiryDate" type="success">
      PERMANENT
    </sv>
    <sv label="Concurrent Users" col="2">
      {{ licenseInfo.concurrentUsersOccupied + ' of ' + licenseInfo.concurrentUsers}}
    </sv>
    <sv label="No. of Users Occupied" col="2">
      {{ licenseInfo.nouOccupied + ' of ' + licenseInfo.numberOfNamedUsers}}
    </sv>
    <sv *ngIf="licenseInfo.productKey" label="No. of Companies Occupied" col="2">
      {{ licenseInfo.nocOccupied + ' of ' + licenseInfo.numberOfCompanies }}
    </sv>
    <sv label="Dealer" col="2">{{ licenseInfo.dealer?.companyName }}</sv>
    <sv label="Accountant" col="2">{{ licenseInfo.accountant?.companyName }}</sv>
  </sv-container>

  <ng-container *ngIf="licenseInfo.modules">
    <sv-container col="3" size="small" layout="horizontal">
      <nz-divider nzText="Modules" [nzOrientation]="'left'"></nz-divider>
      <sv *ngFor="let module of licenseInfo.modules" [label]="module.name" style="font-size: 12px;">
        <i nz-icon nzType="check" nzTheme="outline" *ngIf="module.enabled" class="text-success"></i>
      </sv>
    </sv-container>
  </ng-container>
</nz-spin>
